import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, map, Observable } from 'rxjs';

import { IProductLabel } from '@core/models/product.model';
import { SHOP_PRODUCT_LIST_BLOCK_COMPONENT } from '@core/services/cb2-preview/cb2-preview-bloc-types';
import { previewScenarioData } from '@core/services/cb2-preview/preview-scenario-data.util';
import { previewScenarioForBloc$ } from '@core/services/cb2-preview/preview-scenario-for-bloc.util';
import type { ShopProductListBlockScenarioContent } from '@front-platform/content-builder';
import {
  ShopProductListBlockDataSource,
  SHOP_PRODUCT_LIST_BLOCK_LOADING_VM,
  ShopProductListBlockViewModel,
} from './shop-product-list-block-view-model';

function toShopProductListViewModel(
  content: ShopProductListBlockScenarioContent,
): ShopProductListBlockViewModel {
  return content as unknown as ShopProductListBlockViewModel;
}

@Injectable()
export class ShopProductListBlockPreviewDataSource implements ShopProductListBlockDataSource {
  private readonly selectedLabel$ = new BehaviorSubject<IProductLabel | undefined>(undefined);

  readonly vm$: Observable<ShopProductListBlockViewModel> = combineLatest({
    scenario: previewScenarioForBloc$(SHOP_PRODUCT_LIST_BLOCK_COMPONENT),
    selectedLabel: this.selectedLabel$,
  }).pipe(
    map(({ scenario, selectedLabel }) => {
      if (!scenario) {
        return SHOP_PRODUCT_LIST_BLOCK_LOADING_VM;
      }
      const content = previewScenarioData<ShopProductListBlockScenarioContent>(
        scenario,
        SHOP_PRODUCT_LIST_BLOCK_COMPONENT,
      );
      const resolved = content
        ? toShopProductListViewModel(content)
        : SHOP_PRODUCT_LIST_BLOCK_LOADING_VM;
      return {
        ...resolved,
        selectedLabel,
      };
    }),
  );

  setCatalogFiltersEnabled(_enabled: boolean): void {}

  selectLabel(label: IProductLabel | undefined): void {
    const current = this.selectedLabel$.value;
    if (current === label) {
      this.selectedLabel$.next(undefined);
      return;
    }
    this.selectedLabel$.next(label);
  }
}
